export default {
      id: "icon-headphone-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-headphone",
      toString: function () {
        return this.url;
      }
    }